import { DocPDF } from "../models";
import { eventEmitter } from "../services";

export async function isAvailable(docId: number) {
    const {
        data: { status },
    } = await DocPDF.fetch(`${docId}/available`);
    return status;
}

export async function generatePDF(docId: number) {
    return await DocPDF.fetch(`${docId}/generate`);
}

export async function downloadPDF(docId: number) {
    try {
        const available = await isAvailable(docId);
        if (!available) {
            await generatePDF(docId);

            eventEmitter.emit("pdf.processing", true);
            setTimeout(async () => {
                await downloadPDF(docId);
            }, 15 * 1000);
            return;
        }

        eventEmitter.emit("pdf.processing", false);

        const url = DocPDF.url("GET", `${docId}/download`);
        window.location.assign(url);
        // window.open(url, `_pdf_download_${docId}`)
    } catch (e) {}
}
